<script>

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div page="error" description="Página solicitada no disponible!">
    <div class="text-center w-100">
      <b-img class="m-5"
         center
         src="@assets/images/404.png"
         fluid
         alt="404 error">
      </b-img>
      <h3>Lo sentimos, la página especificada no se encuentra disponible.</h3>
      <h4>Si considera que es un error por favor comunícalo a <a href="mailto:soporte@bibliotecasdigitales.com">soporte técnico.</a></h4>
    </div>
  </div>
</template>

<style lang="scss" module>
</style>
